import CachedObject from './CachedObject';

/**
 * Provides simple in-memory application level cache for objects with cache
 * keys.
 */
export default class Cache<T> {
    private cache: Record<string, CachedObject<T>>;
    private duration: number;

    /**
     * @param duration in milliseconds
     */
    constructor(duration: number) {
        this.duration = duration;
        this.cache = {};
    }

    /**
     * Returns cached object by key or `undefined` if cache is missing or expired.
     */
    get(key: string): T | undefined {
        const value = this.cache[key];
        if (!value || value?.isExpired()) return;
        return value.get();
    }

    /**
     * Sets object with a certain key in cache.
     */
    set(key: string, value: T) {
        this.cache[key] = new CachedObject<T>(this.duration, value);
    }
}
